// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"dac4869d","2436":"6503b220","2577":"6503b220","3455":"6503b220","3775":"6503b220","7488":"6503b220","8003":"6503b220"}[chunkId] + ".chunk.css";
};